import { Pipe, PipeTransform } from '@angular/core';
import { Therapies } from 'src/app/shared/models/therapy';

@Pipe({
  name: 'therapyType',
})
export class TherapyTypePipe implements PipeTransform {
  transform(value: any) {
    if (value === 'undefined' || value === null || isNaN(value) || value === '') {
      return 'ohne Therapieart';
    }

    for (const therapy of Therapies.therapyItems) {
      const retVal = therapy.therapyTypes.find(therapyType => therapyType.id === Number(value));
      if (retVal) {
        return retVal.displayName;
      }
    }
    return 'kein Ergebnis';
  }
}
